import { Search } from "@outschool/business-rules";
import { SearchFilters as SearchFiltersType } from "@outschool/gql-backend-generated";
import { useTranslation } from "@outschool/localization";
import React from "react";
import useActivityString from "../../translations/useActivityString";
import BooleanFilters from "./BooleanFilters";
import { ensureContiguousSearchClassSizeSelection } from "../classSizeSelection";
import isEqual from "lodash/isEqual";

const { getClassSizesFromCapacityFilter, getCapacityFiltersFromClassSize } =
  Search;

// NOTE: CapacityFilter in the Categories is very similar to this, consolidate it in the future.
export default function ClassSizeFilter({
  onChange,
  searchFilters,
}: {
  onChange: (value: Search.CapacityFilterType) => void;
  searchFilters: SearchFiltersType;
}) {
  const { t } = useTranslation(
    "ui-components-website\\src\\Search\\desktop\\ClassSizeFilter",
  );
  const { classSizeOptions } = useActivityString();
  const selectedClassSizes = isEqual(searchFilters, {})
    ? []
    : getClassSizesFromCapacityFilter(searchFilters);

  const handleFilterChange = (selectedValue: Search.ClassSize[]) => {
    const finalSelectedValue = ensureContiguousSearchClassSizeSelection(
      selectedClassSizes,
      selectedValue,
    );

    if (finalSelectedValue.length === 0) {
      onChange({});
      return;
    }

    const filterValue = getCapacityFiltersFromClassSize(finalSelectedValue);
    onChange(filterValue);
  };

  return (
    <BooleanFilters
      label={t("Size")}
      filters={[...classSizeOptions]}
      enabledFilters={selectedClassSizes}
      setEnabledFilters={handleFilterChange}
      onChange={handleFilterChange}
    />
  );
}
